import React from "react";
import { Button, Card } from "react-bootstrap";
import { FaEye } from "react-icons/fa";
import { useNavigate, useLocation } from "react-router-dom";

const ClientRow = ({ client, listState, asCard = false }) => {
  const navigate = useNavigate();
  const location = useLocation();
  //const { data: contratsData, isLoading } = useContratsByClientId(client.id);
 //const contrats = Array.isArray(contratsData?.data)? contratsData.data : [];
  // Logic: determine contract type or fallback
//const contratType = !isLoading && contrats.length > 0? contrats[0]?.type?.name : "Pas de contrat";

 const contract = client.contracts?.[0] ?? null;
  const contratType = contract?.type?.name ?? "Pas de contrat";

  const handleNavigate = () => {
    const currentScrollY = window.scrollY;
    navigate(`/client/${client.id}`, {
      state: {
        from: location.pathname,
        listState: {
          ...listState,
          scrollY: currentScrollY
        }
      }
    });
  };

  // Sur mobile : rendu en card
  if (asCard) {
    return (
      <Card className="h-100 shadow-sm">
        <Card.Body className="d-flex flex-column gap-2">
          {/* Nom du client */}
          <div className="fw-bold" style={{ fontSize: "0.95rem" }}>{client.nom}</div>
          {/* Adresse */}
          <div className="small text-muted">
            <span className="fw-semibold">Adresse :</span> {client.adresse || "—"}
          </div>
          {/* Email */}
          <div className="small">
            <span className="fw-semibold text-muted">Email :</span> {client.email || "—"}
          </div>
          {/* Téléphone */}
          <div className="small">
            <span className="fw-semibold text-muted">Téléphone :</span> {client.telephone || "—"}
          </div>
          {/* Contrat */}
          <div className="small">
            <span className="fw-semibold text-muted">Contrat :</span> {contratType}
          </div>
          {/* Bouton Voir */}
          <div className="mt-auto pt-2 border-top">
            <Button variant="info" size="sm" className="d-flex align-items-center gap-1"
              style={{ backgroundColor: "#4e73df", borderColor: "#4e73df" }}
              onClick={handleNavigate}>
              <FaEye /> Voir
            </Button>
          </div>
        </Card.Body>
      </Card>
    );
  }

  // Sur desktop : rendu en ligne de tableau
  return (
    <tr style={{ cursor: "pointer" }}>
      <td>
        {client.nom}
      </td>
      <td>{client.adresse}</td>
      <td>{client.email}</td>
      <td>{client.telephone}</td>
      <td>{contratType}</td>
      <td>
        <Button 
        variant="info" 
        size="sm"
        style={{ backgroundColor: "#4e73df", borderColor: "#4e73df", width: "32px", height: "32px", padding: 0, display: "inline-flex", alignItems: "center", justifyContent: "center" }}
        onClick={handleNavigate}
        >
          <FaEye />
        </Button>
      </td>
    </tr>
  );
};

export default ClientRow;